// import React from "react";
// import { motion } from "framer-motion";
// import { ChevronDown } from "lucide-react";

// const sections = [
//   {
//     title: "Innovative App Design",
//     text: `We craft visually stunning and user-friendly mobile apps that reflect your brand and engage users. Our design-first approach ensures every app provides an intuitive experience while standing out in the market.`,
//     img: "/inovative.png", // example from Pexels
//   },
//   {
//     title: "Cross‑Platform Compatibility",
//     text: `Our mobile apps work seamlessly across iOS and Android devices. We ensure responsive layouts, smooth performance, and consistent functionality so your users have a flawless experience on any device.`,
//     img: "/cross.jpg", // example from Pixabay
//     reverse: true,
//   },
//   {
//     title: "Dynamic Features",
//     text: `From push notifications to real‑time updates and interactive elements, our apps are built with dynamic functionality to keep users engaged. We leverage the latest technologies to make your app both powerful and intuitive.`,
//     img: "/mobile.jpg", // another Pexels image
//   },
//   {
//     title: "Custom Solutions",
//     text: `Every business has unique needs. We develop fully customized mobile apps tailored to your requirements, offering scalable, secure, and feature-rich solutions that drive growth and enhance user satisfaction.`,
//     img: "/custom.jpg", // Pixabay
//     reverse: true,
//   },
// ];


// const ScrollSection = ({ children }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 60 }}
//     whileInView={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.7, ease: "easeOut" }}
//     viewport={{ once: false, amount: 0.3 }}
//   >
//     {children}
//   </motion.div>
// );

// export default function WebDevelopmentTailwind() {
//   const handleScroll = () => {
//     document.getElementById("web-sections").scrollIntoView({ behavior: "smooth" });
//   };

//   return (
//   <div className="font-poppins text-gray-100 overflow-x-hidden scroll-smooth relative">

//     {/* ✨ Premium Black + Gold Background */}
//     <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0A0A0A] to-[#1A1A1A]">
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,215,0,0.18),_transparent_70%)]"></div>
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(212,175,55,0.22),_transparent_75%)]"></div>
//     </div>

//     {/* Hero Section */}
//     <ScrollSection>
//       <section className="relative h-screen flex flex-col items-center justify-center text-center overflow-hidden">
//         <motion.h1
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="text-[64px] font-extrabold uppercase tracking-wider mb-5 
//                      bg-gradient-to-r from-[#FFD700] to-[#B8860B] text-transparent bg-clip-text drop-shadow-[0_0_10px_rgba(255,215,0,0.5)]"
//         >
//           Mobile App Development
//         </motion.h1>

//         <motion.p
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//           className="text-[20px] max-w-2xl text-gray-300 leading-relaxed"
//         >
//           Why are we the best Web Development Company in Indore?
//         </motion.p>

//         <motion.div
//           className="absolute bottom-20 cursor-pointer animate-bounce text-[#FFD700]"
//           onClick={handleScroll}
//           whileHover={{ scale: 1.2 }}
//         >
//           <ChevronDown size={42} />
//         </motion.div>
//       </section>
//     </ScrollSection>

//     {/* Sections */}
//     <div id="web-sections" className="max-w-6xl mx-auto py-24 px-6 md:px-10 space-y-24 relative z-10">
//       {sections.map(({ title, text, img, reverse }, idx) => (
//         <ScrollSection key={idx}>
//           <div
//             className={`flex flex-col md:flex-row items-center gap-12 ${
//               reverse ? "md:flex-row-reverse" : ""
//             }`}
//           >

//             {/* Text Card */}
//             <motion.div
//               className="flex-1 
//                          bg-gradient-to-br from-[#1A1A1A]/70 to-black/70 
//                          backdrop-blur-[14px] p-10 md:p-12 
//                          rounded-[20px] 
//                          border border-[#FFD700]/30 
//                          shadow-[0_10px_25px_rgba(255,215,0,0.12)]
//                          hover:shadow-[0_14px_35px_rgba(255,215,0,0.20)]
//                          transition-all duration-300"
//               whileHover={{ y: -5 }}
//             >
//               <h2
//                 className="text-[38px] md:text-[38px] font-bold mb-4 
//                            bg-gradient-to-r from-[#FFD700] to-[#DAA520] text-transparent bg-clip-text
//                            relative after:block after:w-20 after:h-[3px] after:bg-[#FFD700] after:rounded mt-2"
//               >
//                 {title}
//               </h2>

//               <p className="text-[17px] md:text-[17px] leading-relaxed text-gray-300">
//                 {text}
//               </p>
//             </motion.div>

//             {/* Image */}
//             <motion.div
//               className="flex-1 text-center"
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.4 }}
//             >
//               <img
//                 src={img}
//                 alt={title}
//                 className="w-full max-w-md md:max-w-lg rounded-[20px] 
//                            border border-[#FFD700]/25 
//                            shadow-[0_12px_30px_rgba(255,215,0,0.18)]"
//               />
//             </motion.div>

//           </div>
//         </ScrollSection>
//       ))}
//     </div>

//     <style>{`
//       @keyframes bounce {
//         0%,100% { transform: translateY(0); }
//         50% { transform: translateY(10px); }
//       }
//       .animate-bounce {
//         animation: bounce 1.8s infinite;
//       }
//     `}</style>
//   </div>
// );

// }





import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const sections = [
  {
    title: "Innovative App Design",
    text: `We craft visually stunning and user-friendly mobile apps that reflect your brand and engage users. Our design-first approach ensures every app provides an intuitive experience while standing out in the market.`,
    img: "/inovative.png",
  },
  {
    title: "Cross-Platform Compatibility",
    text: `Our mobile apps work seamlessly across iOS and Android devices. We ensure responsive layouts, smooth performance, and consistent functionality so your users have a flawless experience on any device.`,
    img: "/cross.jpg",
    reverse: true,
  },
  {
    title: "Dynamic Features",
    text: `From push notifications to real-time updates and interactive elements, our apps are built with dynamic functionality to keep users engaged. We leverage the latest technologies to make your app both powerful and intuitive.`,
    img: "/mobile.jpg",
  },
  {
    title: "Custom Solutions",
    text: `Every business has unique needs. We develop fully customized mobile apps tailored to your requirements, offering scalable, secure, and feature-rich solutions that drive growth and enhance user satisfaction.`,
    img: "/custom.jpg",
    reverse: true,
  },
];

const ScrollSection = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

export default function WebDevelopmentTailwind() {
  const handleScroll = () => {
    document.getElementById("web-sections").scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div className="font-poppins text-gray-100 overflow-x-hidden scroll-smooth relative">

      {/* Background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0A0A0A] to-[#1A1A1A]">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,215,0,0.18),_transparent_70%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(212,175,55,0.22),_transparent_75%)]"></div>
      </div>

      {/* Hero Section */}
      <ScrollSection>
        <section className="relative h-[85vh] sm:h-screen flex flex-col items-center justify-center text-center px-4 sm:px-0">

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-[36px] sm:text-[50px] lg:text-[64px] font-extrabold uppercase tracking-wider mb-4
                       bg-gradient-to-r from-[#FFD700] to-[#B8860B] text-transparent bg-clip-text drop-shadow-[0_0_10px_rgba(255,215,0,0.5)]"
          >
            Mobile App Development
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-[15px] sm:text-[18px] lg:text-[20px] max-w-xl sm:max-w-2xl text-gray-300 px-2 leading-relaxed"
          >
            Why are we the best Web Development Company in Indore?
          </motion.p>

          <motion.div
            className="absolute bottom-10 sm:bottom-20 cursor-pointer animate-bounce text-[#FFD700]"
            onClick={handleScroll}
            whileHover={{ scale: 1.2 }}
          >
            <ChevronDown size={38} />
          </motion.div>
        </section>
      </ScrollSection>

      {/* Sections */}
      <div id="web-sections" className="max-w-7xl mx-auto py-16 sm:py-24 px-4 sm:px-8 space-y-20 sm:space-y-24">

        {sections.map(({ title, text, img, reverse }, idx) => (
          <ScrollSection key={idx}>
            <div className={`flex flex-col md:flex-row items-center gap-10 sm:gap-12 ${reverse ? "md:flex-row-reverse" : ""}`}>

              {/* Text Card */}
              <motion.div
                className="flex-1 
                           bg-gradient-to-br from-[#1A1A1A]/70 to-black/70 
                           backdrop-blur-[14px] p-6 sm:p-8 md:p-10 lg:p-12 
                           rounded-[18px] 
                           border border-[#FFD700]/30 
                           shadow-[0_10px_25px_rgba(255,215,0,0.12)]
                           hover:shadow-[0_14px_35px_rgba(255,215,0,0.20)]
                           transition-all duration-300"
                whileHover={{ y: -5 }}
              >
                <h2 className="text-[28px] sm:text-[34px] md:text-[38px] font-bold mb-3
                               bg-gradient-to-r from-[#FFD700] to-[#DAA520] text-transparent bg-clip-text
                               relative after:block after:w-16 sm:after:w-20 after:h-[3px] after:bg-[#FFD700] after:rounded mt-2"
                >
                  {title}
                </h2>

                <p className="text-[15px] sm:text-[16px] md:text-[17px] leading-relaxed text-gray-300">
                  {text}
                </p>
              </motion.div>

              {/* Image */}
              <motion.div
                className="flex-1 text-center"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
              >
                <img
                  src={img}
                  alt={title}
                  className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-[20px]
                             border border-[#FFD700]/25 
                             shadow-[0_12px_30px_rgba(255,215,0,0.18)]"
                />
              </motion.div>

            </div>
          </ScrollSection>
        ))}
      </div>

      {/* Bounce Animation */}
      <style>{`
        @keyframes bounce {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(10px); }
        }
        .animate-bounce {
          animation: bounce 1.8s infinite;
        }
      `}</style>

    </div>
  );
}
